module.exports = __webpack_public_path__ + "media/static/icons/icon-sandbar--green-ce91eac53403a6b612d88402b2925628.svg";